module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-2 text-xs-left grey-lighten-4",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.chips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'primary white--text' : '',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadSlaScoreBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(chip) + "\n                  ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.enableChip === 'Specific Month') ? _c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs10": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgSLAScoreMon",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.selectedYearMonth
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedYearMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedYearMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Month & Year",
            "rules": [_vm.rules.required],
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": ""
          },
          slot: "activator",
          model: {
            value: (_vm.lslaScoreInput.sla_monthAndYear),
            callback: function($$v) {
              _vm.$set(_vm.lslaScoreInput, "sla_monthAndYear", $$v)
            },
            expression: "lslaScoreInput.sla_monthAndYear"
          }
        }, on))]
      }
    }], null, false, 1337137875),
    model: {
      value: (_vm.dlgSLAScoreMon),
      callback: function($$v) {
        _vm.dlgSLAScoreMon = $$v
      },
      expression: "dlgSLAScoreMon"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lslaScoreInput.sla_monthAndYear),
      callback: function($$v) {
        _vm.$set(_vm.lslaScoreInput, "sla_monthAndYear", $$v)
      },
      expression: "lslaScoreInput.sla_monthAndYear"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgSLAScoreMon = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgSLAScoreMon.save(_vm.lslaScoreInput.sla_monthAndYear)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs2": "",
      "sm2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getSpecificMonthDetails()
      }
    }
  }, [_vm._v("Go")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('v-btn', {
    attrs: {
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAsPdf()
      }
    }
  }, [_vm._v("Save as Pdf")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": "",
      "id": "pdf_report"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 title"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-s-left pt-2 headtext"
  }, [_c('h2', [_vm._v(_vm._s(_vm.config.COMM_NAME))])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left pt-2"
  }, [_vm._v("SLA Score Card [ " + _vm._s(this.fromMonth) + "-" + _vm._s(this.fromYear) + " ]")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('img', {
    attrs: {
      "height": "45",
      "src": require("../../static/img/logo/smartility_admin.png")
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-top": "1px solid brown"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.SLAScoreCardHeader,
      "items": _vm.slaScoreList,
      "item-class": _vm.itemRowBackground,
      "disable-initial-sort": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "myBorder pa-2",
          staticStyle: {
            "background-color": "#FBFFDF"
          },
          on: {
            "click": function($event) {
              return _vm.updateSLAScoreCard(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "myBorder",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(props.item.comp_cat))]), _vm._v(" "), _c('td', {
          staticClass: "myBorder breakline pa-2",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(props.item.kpi_area))]), _vm._v(" "), _c('td', {
          staticClass: "myBorder breakline pa-2",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(props.item.kpi_measure))]), _vm._v(" "), _c('td', {
          staticClass: "myBorder",
          staticStyle: {
            "background-color": "#FEE1C3",
            "font-size": "20px",
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(props.item.self_score))]), _vm._v(" "), _c('td', {
          staticClass: "myBorder",
          staticStyle: {
            "background-color": "#FEE1C3",
            "font-size": "20px",
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(props.item.ops_score))]), _vm._v(" "), _c('td', {
          staticClass: "myBorder",
          staticStyle: {
            "background-color": "#CDFEC3",
            "font-size": "20px",
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(props.item.mc_score) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "myBorder breakline pa-2",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(props.item.remarks) + " ")])])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pa-3": ""
    }
  }, [_c('span', {
    staticClass: "primary--text header pl-0",
    staticStyle: {
      "font-size": "17px",
      "text-align": "right"
    }
  }, [_vm._v("Total Score")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "type": "Number",
      "maxlength": "2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pa-3": ""
    }
  }, [_c('span', {
    staticClass: "primary--text header pl-0",
    staticStyle: {
      "font-size": "17px",
      "text-align": "right"
    }
  }, [_vm._v("Percentage Score")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "type": "Number",
      "maxlength": "2"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "900px",
      "full-height": ""
    },
    model: {
      value: (_vm.showSubmitScore),
      callback: function($$v) {
        _vm.showSubmitScore = $$v
      },
      expression: "showSubmitScore"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lEditSLAForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text py-0",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("\n                SLA Score - " + _vm._s(_vm.lSLAScore.comp_cat) + "\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSubmitScore = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("KPI Area")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "rows": "8",
      "readonly": "",
      "multi-line": ""
    },
    model: {
      value: (_vm.lSLAScore.kpi_area),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "kpi_area", $$v)
      },
      expression: "lSLAScore.kpi_area"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("KPI Measure")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "background-color": "amber lighten-4",
      "readonly": "",
      "multi-line": "",
      "rows": "8",
      "dense": "",
      "box": ""
    },
    model: {
      value: (_vm.lSLAScore.kpi_measure),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "kpi_measure", $$v)
      },
      expression: "lSLAScore.kpi_measure"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "d-flex pa-2",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("FM Score")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "type": "Number",
      "maxlength": "1",
      "disabled": _vm.config.IS_FM !== true
    },
    model: {
      value: (_vm.lSLAScore.self_score),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "self_score", $$v)
      },
      expression: "lSLAScore.self_score"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("OPS Score")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "type": "Number",
      "maxlength": "1"
    },
    model: {
      value: (_vm.lSLAScore.ops_score),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "ops_score", $$v)
      },
      expression: "lSLAScore.ops_score"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("MC Score")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "box": "",
      "hide-details": "",
      "type": "Number",
      "maxlength": "1",
      "disabled": _vm.config.ROLE_NAME !== 'President' && _vm.config.ROLE_NAME !== 'Joint Secretary' && _vm.config.ROLE_NAME !== 'Secretary' && _vm.config.ROLE_NAME !== 'Treasurer' && _vm.config.ROLE_NAME !== 'Vice President'
    },
    model: {
      value: (_vm.lSLAScore.mc_score),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "mc_score", $$v)
      },
      expression: "lSLAScore.mc_score"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs": "",
      "12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "multi-line": "",
      "dense": "",
      "box": "",
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lSLAScore.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lSLAScore, "remarks", $$v)
      },
      expression: "lSLAScore.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "red lighten-1",
      "text-color": "white"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSubmitScore = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "green lighten-1",
      "text-color": "white",
      "type": "submit",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08afe0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlaScoreCard.vue
// module id = 793
// module chunks = 9